// import { PickersShortcutsItem } from "@mui/x-date-pickers/PickersShortcuts";
// import { DateRange } from "@mui/x-date-pickers-pro";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
// import hrmsDataService from "../services/hrms.services";
// import { DateRangePicker } from 'react-date-range';
// import 'react-date-range/dist/styles.css';
// import 'react-date-range/dist/theme/default.css';
// import {
//   getFirestore,
//   updateDoc,
//   doc,
//   query,
//   getDocs,
//   collection,
//   where,
//   orderBy,
// } from "firebase/firestore";
// import { Timestamp } from "firebase/firestore";
// import { addMonths, endOfMonth, startOfMonth, startOfYear, endOfYear } from "date-fns/esm";
// import CloseIcon from "@mui/icons-material/Close";
import {
  EyeTwoTone,
  CheckCircleFilled,
  DislikeOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import Check from "../../assets/check-svgrepo-com.svg";
import Icon from "@ant-design/icons";
import { addDays } from "date-fns";
import ClearIcon from "@mui/icons-material/Clear";
import FilterListIcon from "@mui/icons-material/FilterList";
import emailjs from "@emailjs/browser";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { formatDate } from "@fullcalendar/core";
import { createStaticRanges } from "react-date-range";
import PredefinedRanges from "rsuite/esm/DatePicker/PredefinedRanges.js";
import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { Modal, Spin, Card, Typography as typography_antd } from "antd";
import LeaveStatus from "../../Components/LeaveStatus";
import moment from "moment";
import LeaveStyle from "../../Components/LeavesStyle";
import ErrorIcon from "@mui/icons-material/Error";
import SearchIcon from "@mui/icons-material/Search";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Tooltip from "@mui/material/Tooltip";
import { DateRangePicker } from "rsuite";
import { Calendar } from "@rsuite/icons";
import "rsuite/dist/rsuite.min.css";
import { addMonths, startOfMonth, endOfMonth, startOfYear, endOfYear, format } from "date-fns";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice.js";
import { Navigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  InputAdornment,
  TextField,
  Pagination,
  Drawer,
  IconButton,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Autocomplete,
  Box,
  Tabs,
  Tab,
  Checkbox,
  Popper,
  ClickAwayListener,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import dayjs, { Dayjs } from "dayjs";
import axios from "axios";
import CryptoJS from "crypto-js";

const { Title, Text } = typography_antd;
const { default: env } = require("../../config/env.js");

const shortcutsItems = [
  {
    label: "This Week",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("week"), today.endOf("week")];
    },
  },
  {
    label: "Last Week",
    getValue: () => {
      const today = dayjs();
      const prevWeek = today.subtract(7, "day");
      return [prevWeek.startOf("week"), prevWeek.endOf("week")];
    },
  },
  {
    label: "Last 7 Days",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(7, "day"), today];
    },
  },
  {
    label: "Current Month",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("month"), today.endOf("month")];
    },
  },
  {
    label: "Privious Month",
    getValue: () => {
      const today = dayjs();
      const startOfNextMonth = today.endOf("month").add(1, "day");
      return [startOfNextMonth, startOfNextMonth.endOf("month")];
    },
  },
  { label: "Reset", getValue: () => [null, null] },
];

export default function EmployeeLeaves(props) {
  const [value, setValue] = React.useState([null, null]);
  const [Filtervalue, setFilterValue] = React.useState(0);
  const [rowData, setRowData] = useState({});
  const [activityArr, setActivityArr] = useState([]);
  const [loading, setloading] = useState(true);
  const [showOpen, setShowOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [subtypesofLeave, setSubTypesOfLeave] = useState();
  const [openFilterModal, setopenFilterModal] = useState(false);
  const [leaves, setLeaves] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), 0, 1)
  );
  const [endDate, setEndDate] = useState(
    new Date(new Date().getFullYear(), 11, 31)
  );

  const [showPicker, setShowPicker] = useState(false);
  const [date, setDate] = useState([new Date(), new Date()]);
  // stores the selected start date and end date
  const [range, setRange] = useState([new Date(), new Date()])
  // controls visiblity(manages whether the calendar is shown or hidden)
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null);
  const [users, setUsers] = useState();
  const [selectedUsers, setSelectedUsers] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedUserCheckboxes, setSelectedUserCheckboxes] = useState([]);
  const [selectedStatusCheckboxes, setSelectedStatusCheckboxes] = useState([]);
  // const [filteredArr, setFilterdArr] = useState([]);
  const [filteredArrD, setFilterdArrD] = useState([]);
  const [statusfilter, setStatusfilter] = useState([]);
  const [userfilter, setUserfilter] = useState([]);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(20);
  const token = useSelector((state) => state.auth.token);
  const [searchText, setSearchText] = useState("");
  const [filteredActivityArr, setFilteredActivityArr] = useState([]);
  // let Roles = props.role;
  const dispatch = useDispatch();
  
  const state = useSelector((state) => state);
  let action_taken_by_Name = props?.userData?.name;

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  useEffect(() => {
    if (token) {
      getLeaveData();
    }
  }, [token, currentPage, count, limit, selectedUserCheckboxes, selectedStatusCheckboxes, startDate, endDate]);

  const getLeaveData = async () => {
    try {
      setloading(true);
      const encodedUsernames =
        selectedUserCheckboxes.length > 0
          ? encodeURIComponent(JSON.stringify(selectedUserCheckboxes))
          : "";
      const encodedStatusnames =
        selectedStatusCheckboxes.length > 0
          ? encodeURIComponent(JSON.stringify(selectedStatusCheckboxes))
          : "";
      const urlStartDate = moment(startDate).format("YYYY-MM-DD");
      const urlEndDate = moment(endDate).format("YYYY-MM-DD");

      const getLeaves = CryptoJS.SHA256("/getLeaves" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      // Encrypt data
      function encryptData(data) {
        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return encodeURIComponent(encrypt);
      }

      const encryptedName = encryptData(encodedUsernames);
      const encryptedStatusName = encryptData(encodedStatusnames);
      const encryptedStartDate = encryptData(urlStartDate);
      const encryptedEndtDate = encryptData(urlEndDate);
      const encryptedCurrentPage = encryptData(currentPage);
      const encryptedLimit = encryptData(limit);

      const response = await fetch(`${env.backend_api_endpoint}/${getLeaves}?name=${encryptedName}&status=${encryptedStatusName}&startDate=${encryptedStartDate}&endDate=${encryptedEndtDate}&page=${encryptedCurrentPage}&limit=${encryptedLimit}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData?.status === 400) {
          setloading(false);
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
        if (errorData?.status === 404) {
          setActivityArr([]);
          setFilteredActivityArr([]);
          setloading(false);
        }
        throw new Error("Error fetching attendance details");
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200 && successData.data) {

          // Decrypt backend response
          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          setActivityArr(decryptedData.data);
          setFilteredActivityArr(decryptedData.data);
          setloading(false);
          setTotalPages(decryptedData?.totalPages);
        }
      }
    } catch (error) {
      console.error("Error fetching attendance details:", error.message);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  const acceptPopup = (item) => {
    confirmHandler(item, "accept");
    // setSelectedItem(item);
    // setSelectedAction("accept");    
    // setAlertText("Are you sure you want to Accept this leave?");
    // setShowOpen(true);
  };

  const rejectPopup = (item, cancel) => {
    confirmHandler(item, "reject");
    // setSelectedItem(item);
    // setSelectedAction("reject");
    // setAlertText(`Are you sure you want to ${cancel} this leave?`);
    // setShowOpen(true);
  };

  const cancelHandler = () => {
    setSelectedItem({});
    setShowSuccess(true);
  };

  const closeSuccess = () => {
    setShowSuccess(false);
    setSelectedAction("");
    setAlertText("");
    // getTodo();
  };

  const confirmHandler = async (item, action) => {
    setShowOpen(false);
    setloading(true);
    let status = action == "accept" ? "Approved" : "Rejected";
    try {

      const data = {
        leaveId: item?.id,
        leaveStatus: status
      }

      // Encrypt data
      const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

      //Encrypt api endpoint
      const updateLeaves = CryptoJS.SHA256("/updateLeaves" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(`${env.backend_api_endpoint}/${updateLeaves}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        body: JSON.stringify({ encryptedData: encryptedBody }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200) {
          if (action == "accept") {
            handleApproved("Approved");
            // getLeaveData();
            // cancelHandler();
            // handleClose();
          }
          if (action == "reject") {
            handleApproved("Rejected");
            // getLeaveData();
            // cancelHandler();
            // handleClose();
          }
          getLeaveData();
          cancelHandler();
          handleClose();
        }
      }
    } catch (error) {
      console.error("Error Leave Data in:", error.message);
    }
  };

  const handleApproved = async (leaveStatus) => {
    var templateParams = {
      date:
        moment(new Date(selectedItem?.start_date)).format("DD-MM-YYYY") +
        " to " +
        moment(new Date(selectedItem?.end_date)).format("DD-MM-YYYY"),
      to_name: selectedItem?.applied_user_name,
      Leave_type: selectedItem?.leave_title,
      sub_leave_type: selectedItem?.sub_leave_title,
      duration:
        selectedItem.leave_duration_title == "Second Half" || "First Half"
          ? "Half Day"
          : selectedItem.days + " days",
      duration_period: selectedItem?.leave_duration_title,
      reason: selectedItem?.leave_reason,
      status: leaveStatus,
      to_email: selectedItem?.company_email,
      subject: `Your Leave is ${leaveStatus} ${env.subject_mode}`,
      type: "leave_approval",
      from_email: env.basic_email_params.from_email,
    };
    await axios.post(`${env.backend_api_endpoint}/send-email`, {
      ...templateParams,
    });
  };

  const handleClose = () => {
    setRowData({});
  };

  const data = activityArr;
  const formatSelectedDates = (startDate, endDate) => {
    if (startDate && endDate) {
      const startFormatted = startDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      const endFormatted = endDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      return `${startFormatted} | ${endFormatted}`;
    }
    return "DD-MM-YYYY | DD-MM-YYYY";
  };

  const [selectedDatesText, setSelectedDatesText] = useState(
    formatSelectedDates(startDate, endDate)
  );

  const defaultFilter = (newStartDate, newEndDate) => {
    let updatedStatusDateFilters = [];
    let updatedUSERDateFilters = [];
    const filteredLeaveRanges = activityArr?.filter((range) => {
      const leaveStartDate = new Date(range?.start_date);
      return leaveStartDate >= newStartDate && leaveStartDate <= newEndDate;
    });

    filteredLeaveRanges.forEach((ele) => {
      let roleF = {
        label: `${ele.leave_status}`,
        value: `${ele.leave_status}`,
      };

      let USERF = {
        name: `${ele.applied_user_name}`,
      };

      if (!updatedUSERDateFilters.some((item) => item.name === USERF.name)) {
        updatedUSERDateFilters.push(USERF);
      }

      if (
        !updatedStatusDateFilters.some((item) => item.value === roleF.value)
      ) {
        updatedStatusDateFilters.push(roleF);
      }
    });
    setStatusfilter(updatedStatusDateFilters);
    setUserfilter(updatedUSERDateFilters);
  };

  // new Status  update listing Function based on select
  const handleStautsChange = (e) => {
    const searchStatus = e.target.value;
    setSearchStatus(searchStatus);

    setSelectedStatusCheckboxes(searchStatus ? [searchStatus] : []);
    // getLeaveData();
  }

  // handle name search
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value.trim() === '') {
      setFilteredActivityArr(activityArr)
    } else {
      const filtered = activityArr.filter((item) =>
        item.applied_user_name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredActivityArr(filtered);
    }
  }

  // custom ranges
  const now = new Date();

  //predefined ranges   
  const predefineRanges = [
    {
      label: 'This Year',
      value: [
        new Date(now.getFullYear(), 0, 1),
        new Date(now.getFullYear(), 11, 31)
      ]
    },
    {
      label: 'This Month',
      value: [
        new Date(now.getFullYear(), now.getMonth(), 1),
        new Date(now.getFullYear(), now.getMonth() + 1, 0)
      ]
      // value: () => [startOfMonth(new Date()), new Date()],
      // key: 1
    },
    {
      label: 'Last Month',
      value: [
        new Date(now.getFullYear(), now.getMonth() - 1, 1),
        // day 0 of this month is last day of previous month:
        new Date(now.getFullYear(), now.getMonth(), 0)
      ]
    },

    {
      label: 'Last year',
      value: [
        new Date(now.getFullYear() - 1, 0, 1),
        new Date(now.getFullYear() - 1, 11, 31),
      ]
    }
  ]

  // custom filter
  const [filteredArr, setFilterdArr] = useState([]);

  const customDataFilter = (startDate, endDate) => {
    const filtered = activityArr.filter((r) => {
      const entryDate = new Date(r?.start_date);
      return entryDate >= startDate && entryDate <= endDate
    });
    setFilterdArr(filtered);
  }
  // holds formated date string 
  const [dateRange, setDateRange] = useState(predefineRanges[0].value);

  const handleRangeChange = ([start, end]) => {
    setDateRange([start, end]);
    setStartDate(start);
    setEndDate(end);
    customDataFilter(start, end);
  }

  const handleFilterdSumbit = () => {
    getLeaveData();
  }

  // cancle button 
  const handleCloseFilter = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    const end = new Date(now.getFullYear(), 11, 31);

    setStartDate(start);
    setEndDate(end);
    getLeaveData()
    // setPickerOpen(false);
  }

  // date range picker open and close 
  // const [pickerOpen, setPickerOpen] = useState(false);
  // clear or close button date range picker
  const handleClosePicker = () => {
    const defaultRange = predefineRanges[0]?.value;

    setDateRange(defaultRange);
    handleRangeChange(defaultRange);
  }

  const FilterPopup = () => {
    defaultFilter(startDate, endDate);
    setopenFilterModal(true);
  };

  const handleClearFilter = () => {
    setSelectedUserCheckboxes([]);
    setSelectedStatusCheckboxes([]);
    setUserfilter([]);
    setStatusfilter([]);
    setSearchStatus("");
    setSearchQuery("");
    setStartDate(new Date(new Date().getFullYear(), 0, 1));
    setEndDate(new Date(new Date().getFullYear(), 11, 31));
    setSelectedDatesText(
      formatSelectedDates(
        new Date(new Date().getFullYear(), 0, 1),
        new Date(new Date().getFullYear(), 11, 31)
      )
    );
    // getTodo();
    setCount(1);
    setopenFilterModal(false);
  };

  const closeFilterModel = () => {
    setopenFilterModal(false);
    setSearchQuery("");
    setSearchStatus("");
  };

  const handleTChange = (event, newValue) => {
    setFilterValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleFilterYear = (key) => {
    if (key == 1) {
      setStartDate(startOfMonth(new Date()));
      setEndDate(new Date());
      defaultFilter(startOfMonth(new Date()), new Date());
    }
    if (key == 2) {
      setStartDate(startOfMonth(addMonths(new Date(), -1)));
      setEndDate(endOfMonth(addMonths(new Date(), -1)));
      defaultFilter(
        startOfMonth(addMonths(new Date(), -1)),
        endOfMonth(addMonths(new Date(), -1))
      );
    }
    if (key == 3) {
      setStartDate(new Date(new Date().getFullYear(), 0, 1));
      setEndDate(new Date(new Date().getFullYear(), 11, 31));
      defaultFilter(
        new Date(new Date().getFullYear(), 0, 1),
        new Date(new Date().getFullYear(), 11, 31)
      );
    }
    if (key == 4) {
      setStartDate(new Date(new Date().getFullYear() - 1, 0, 1));
      setEndDate(new Date(new Date().getFullYear() - 1, 11, 31));
      defaultFilter(
        new Date(new Date().getFullYear() - 1, 0, 1),
        new Date(new Date().getFullYear() - 1, 11, 31)
      );
    }
  };

  const handleDateChange = (e) => {
    if (e.$d !== null) {
      const newStartDate = e.$d;
      setStartDate(newStartDate);
      const newSelectedDatesText = formatSelectedDates(newStartDate, endDate);
      defaultFilter(newStartDate, endDate);
    }
  };

  const handleToDateChange = (e) => {
    const newEndDate = e.$d;
    setEndDate(newEndDate);
    const newSelectedDatesText = formatSelectedDates(startDate, newEndDate);
    defaultFilter(startDate, newEndDate);
  };

  const handleSearchChange = (e) => {
    const searchText = e.target.value;
    setSearchQuery(searchText);
    const updateduserFilters = [];

    if (searchText !== "") {
      const filteredData = userfilter?.filter((row) =>
        row.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setUserfilter(filteredData);
    } else {
      activityArr?.forEach((ele) => {
        if (
          ele.start_date.toDate() >= startDate &&
          ele.end_date.toDate() <= endDate
        ) {
          let roleF = {
            name: `${ele.applied_user_name}`,
          };
          if (!updateduserFilters.some((item) => item.name === roleF.name)) {
            updateduserFilters.push(roleF);
          }
        }
      });
      setUserfilter(updateduserFilters);
    }
  };

  const handleSearchStatus = (e) => {
    const searchStatus = e.target.value;
    setSearchStatus(searchStatus);

    setSelectedStatusCheckboxes(searchStatus ? [searchStatus] : [])


    const updatedStatusFilters = [];

    if (searchStatus !== "") {
      const Filtersearch = statusfilter?.filter((row) =>
        row.label.toLowerCase().includes(searchStatus.toLowerCase())
      );
      setStatusfilter(Filtersearch);
    } else {
      activityArr?.forEach((ele) => {
        if (
          ele.start_date.toDate() >= startDate &&
          ele.end_date.toDate() <= endDate
        ) {
          let roleF = {
            label: `${ele.leave_status}`,
            value: `${ele.leave_status}`,
          };
          if (
            !updatedStatusFilters.some((item) => item.value === roleF.value)
          ) {
            updatedStatusFilters.push(roleF);
          }
        }
      });
      setStatusfilter(updatedStatusFilters);

      getLeaveData()
    }

  };

  const handleChange = (name) => {
    const Selectedstatus = selectedStatusCheckboxes.includes(name)
      ? selectedStatusCheckboxes.filter((item) => item !== name)
      : [...selectedStatusCheckboxes, name];
    setSelectedStatusCheckboxes(Selectedstatus);
    let updateduserFilters = [];

    if (Selectedstatus.length == 0) {
      activityArr?.forEach((ele) => {
        const tempStartDate = new Date(ele.start_date);
        const tempEndDate = new Date(ele.end_date);
        if (tempStartDate >= startDate && tempEndDate <= endDate) {
          let roleF = {
            name: `${ele.applied_user_name}`,
          };
          if (!updateduserFilters.some((item) => item.name === roleF.name)) {
            updateduserFilters.push(roleF);
          }
        }
      });
      setUserfilter(updateduserFilters);
    } else {
      Selectedstatus.forEach((selected) => {
        activityArr?.forEach((element) => {
          const tempStartDate = new Date(element.start_date);
          const tempEndDate = new Date(element.end_date);
          if (
            element.leave_status === selected &&
            tempStartDate >= startDate &&
            tempEndDate <= endDate
          ) {
            let roleF = {
              name: `${element.applied_user_name}`,
            };
            if (!updateduserFilters.some((item) => item.name === roleF.name)) {
              updateduserFilters.push(roleF);
            }
          }
        });
      });
      setUserfilter(updateduserFilters);
    }
  };

  const handleUserChange = (name) => {
    const Selectedname = selectedUserCheckboxes.includes(name)
      ? selectedUserCheckboxes.filter((item) => item !== name)
      : [...selectedUserCheckboxes, name];
    setSelectedUserCheckboxes(Selectedname);
    let updatedStatusFilters = [];

    if (Selectedname.length == 0) {
      activityArr?.forEach((ele) => {
        const tempStartDate = new Date(ele.start_date);
        const tempEndDate = new Date(ele.end_date);
        if (tempStartDate >= startDate && tempEndDate <= endDate) {
          let roleF = {
            label: `${ele.leave_status}`,
            value: `${ele.leave_status}`,
          };
          if (
            !updatedStatusFilters.some((item) => item.value === roleF.value)
          ) {
            updatedStatusFilters.push(roleF);
          }
        }
      });
      setStatusfilter(updatedStatusFilters);
    } else {
      Selectedname.forEach((selected) => {
        activityArr?.forEach((element) => {
          const tempStartDate = new Date(element.start_date);
          const tempEndDate = new Date(element.end_date);
          if (
            element.applied_user_name === selected &&
            tempStartDate >= startDate &&
            tempEndDate <= endDate
          ) {
            let roleF = {
              label: `${element.leave_status}`,
              value: `${element.leave_status}`,
            };
            if (
              !updatedStatusFilters.some((item) => item.value === roleF.value)
            ) {
              updatedStatusFilters.push(roleF);
            }
          }
        });
      });
      setStatusfilter(updatedStatusFilters);
    }
  };

  const filterdsumbit = () => {
    getLeaveData();
    setopenFilterModal(false);
  };

  function userProfileData(users) {
    return users?.map((userData) => ({
      label: userData?.name,
      value: userData?.name,
    }));
  }

  return (
    <LeaveStyle>
      <div className="site-card-border-less-wrapper" style={{ paddingTop: "0px" }}>
        <Card
          bodyStyle={{ height: "calc(100vh - 75px)", padding: "10px" }}
          bordered={false}
          style={{
            margin: 5,

          }}
        >
          <div className="employeeleaveHeader">
            <div className="titleLeaves" >
              <Title
                level={2}
                style={{
                  color: "#244DA0",
                  fontFamily: "ImportedMilliardBold",
                  fontWeight: 500,
                  marginBottom: "16px",
                }}
              >
                Employee Leaves
              </Title>
              {/* <div className="iconFilterDown" style={{ marginTop: "0px" }}>
                <FilterListIcon onClick={FilterPopup} />
              </div> */}
            </div>
          </div>
          {/* Serach Bar */}
          <div className="card bg-light border-2 rounded-lg shadow-sm p-4 mb-6" >
            <div className="flex flex-wrap align-items-center gap-4" style={{ fontFamily: "MilliardBook" }}>

              <TextField
                placeholder="Search Employees Leaves..."
                value={searchText}
                onChange={handleSearch}
                style={{
                  width: "66%",
                  paddingTop: "1%",
                  paddingBottom: "1%",
                  paddingRight: "1%",
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  sx: {
                    height: 40,
                    fontFamily: "Milliard"
                  },
                }}
              />

              {/* filter by Status */}
              <Box sx={{ minWidth: 140 }} boxSizing={"content-box"}
                style={{
                  // width: "full",
                  // paddingLeft: "16px",
                  paddingTop: "1%",
                  paddingBottom: "1%",
                  paddingRight: "1%",
                }}>
                <FormControl fullWidth>
                  <Select
                    id="status-select"

                    displayEmpty
                    value={searchStatus}
                    onChange={handleStautsChange}
                    sx={{
                      height: 40,
                    }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Approved">Approved</MenuItem>
                    <MenuItem value="Rejected">Rejected</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Cancel">Cancel</MenuItem>
                  </Select>

                </FormControl>
              </Box>

              {/* filter by range  */}
              < Box sx={{ minWidth: 140, }} boxSizing={"content-box"}
                style={{
                  // width: "full",
                  // paddingLeft: "16px",
                  paddingTop: "1%",
                  paddingBottom: "1%",
                  // paddingRight: "1%",
                }}
              >
                <style>
                  {`       
                        .rs-picker-toggle-value{
                          color: black !important ;
                        }
                         .rs-picker-toggle.rs-btn {
                            color: black ;
                            height: 40px !important; 
                            border: 1px solid #c4c4c4 !important; 
                            border-radius: 4px !important;
                            box-shadow: none !important;
                            display: flex;
                            align-items: center;
                          }

                          /*set border color to black at time of hover*/
                          .rs-picker-toggle.rs-btn:hover {
                            border-color: black !important;
                          }

                          /* When the input is focused (selected), set the border color to blue */
                           .rs-picker-toggle-textbox{                       
                            border:  1px solid #1675e0 !important;
                            padding: 1px 10px !important;
                          } 
                          .rs-stack-item .rs-picker-toggle-caret{
                            display: none !important;
                          }
                          .rs-picker-default .rs-picker-toggle{
                            padding-right: 11px !important;
                          }
                      
                    `}
                </style>

                <DateRangePicker
                  cleanable={false}
                  ranges={predefineRanges}
                  value={dateRange}
                  size="small"
                  onChange={handleRangeChange}
                  showOneCalendar
                  format="dd-MM-yyyy"
                  onKeyDown={(e) => {
                    if (!/[0-9/]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  renderValue={(value) => {
                    const [start, end] = value;
                    return (
                      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                        <Calendar />
                        {format(start, 'dd-MM-yyyy')} ~ {format(end, 'dd-MM-yyyy')}
                      </span>
                    )

                  }}
                // onOk={handleFilterdSumbit}
                // onClean={() => handleRangeChange(predefineRanges[0]?.value)}
                // onClean={handleClosePicker}
                />
              </Box>
            </div>
          </div>

          {/* View Employee Leave Modal */}
          <Dialog
            className="Leave_dialog_m"
            open={Object.keys(rowData)?.length !== 0}
            onClose={handleClose}
          >
            <DialogTitle id="dialog_title">
              {rowData.applied_user_name}{" "}
              <CloseIcon
                style={{ color: "grey", cursor: "pointer" }}
                onClick={handleClose}
              />
            </DialogTitle>
            <Divider />
            <DialogContent>
              <div className="Leave_dialog">
                <Typography variant="subtitle1">Status</Typography>
                <Typography variant="body2">
                  {rowData.leave_status ? rowData.leave_status : "-"}
                </Typography>
                <Typography variant="subtitle1">Applied On</Typography>
                <Typography variant="body2">
                  {rowData.applied_date && (
                    <>
                      {moment(new Date(rowData.applied_date)).format(
                        "DD-MM-YYYY"
                      )}
                    </>
                  )}
                </Typography>

                <Typography variant="subtitle1">Date</Typography>
                <Typography variant="body2">
                  {rowData.start_date && (
                    <>
                      {moment(new Date(rowData.start_date)).format(
                        "DD-MM-YYYY"
                      )}{" "}
                      to{" "}
                      {moment(new Date(rowData.end_date)).format("DD-MM-YYYY")}
                    </>
                  )}
                </Typography>
                <Typography variant="subtitle1">Leave Type</Typography>
                <Typography variant="body2">
                  {rowData.leave_title ? rowData.leave_title : "-"}
                </Typography>

                <Typography variant="subtitle1">Sub Leave Type</Typography>
                <Typography variant="body2">
                  {rowData.sub_leave_title ? rowData.sub_leave_title : "-"}
                </Typography>

                <Typography variant="subtitle1">Duration</Typography>
                <Typography variant="body2">
                  {rowData.days ? rowData.days : "-"}
                </Typography>

                <Typography variant="subtitle1">Duration Period</Typography>
                <Typography variant="body2">
                  {rowData.leave_duration_title
                    ? rowData.leave_duration_title
                    : "-"}
                </Typography>

                <Typography variant="subtitle1">Reason</Typography>
                <Typography variant="body2">
                  {rowData.leave_reason ? rowData.leave_reason : "-"}
                </Typography>
                <Typography variant="subtitle1">Action By</Typography>
                <Typography variant="body2">
                  {rowData.action_taken_by ? rowData.action_taken_by : "-"}
                </Typography>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="500px"
                  gap={2}
                  mt={1}
                >
                  {rowData.leave_status === "Pending" && (
                    <>
                      {/* Approve Button */}
                      <Button
                        onClick={() => acceptPopup(rowData)}
                        sx={{
                          backgroundColor: "green",
                          borderRadius: "6px",
                          color: "white",
                          textTransform: 'none',
                          fontFamily: "MilliardMedium",
                          '&:hover': {
                            backgroundColor: "green",
                          }
                        }}
                      >Approved</Button>
                      {/* Reject Button */}
                      <Button
                        onClick={() => rejectPopup(rowData, "Reject")}
                        sx={{
                          backgroundColor: "red",
                          borderRadius: "6px",
                          color: "white",
                          textTransform: 'none',
                          fontFamily: "MilliardMedium",
                          '&:hover': {
                            backgroundColor: "red",
                          }
                        }}
                      >Reject</Button>
                    </>
                  )}
                  {/* if Approved show Cancel button */}
                  {rowData.leave_status === "Approved" && (
                    <Button
                      onClick={() => rejectPopup(rowData, "Cancel Leave")}
                      sx={{
                        backgroundColor: "red",
                        borderRadius: "6px",
                        color: "white",
                        textTransform: 'none',
                        justifyContent: 'center',
                        '&:hover': {
                          backgroundColor: "red"
                        },
                      }}
                    >Cancel Leave</Button>
                  )}
                </Box>
              </div>
            </DialogContent>
          </Dialog>

          {/* sure want to status Model*/}
          <Dialog open={showOpen}>
            <DialogContent>
              <center>
                <ErrorIcon style={{ fontSize: "50px" }} />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                {alertText}
              </p>
            </DialogContent>
            <DialogActions
              style={{ justifyContent: "center", marginBottom: "10px" }}
            >
              <Button
                block
                size="large"
                key="submit"
                type="primary"
                onClick={() => setShowOpen(false)}
                style={{
                  backgroundColor: "#E20E0E",
                  borderRadius: "6px",
                  fontWeight: "500",
                  borderColor: "#E20E0E",
                  textTransform: "none",
                  width: "120px",
                  color: "white",
                  fontFamily: "MilliardMedium"
                }}
              >
                No
              </Button>
              <Button
                size="large"
                block
                key="back"
                id="btnDelete"
                onClick={confirmHandler}
                style={{
                  backgroundColor: "#244DA0",
                  borderRadius: "6px",
                  color: "white",
                  fontWeight: "500",
                  borderColor: "#244DA0",
                  textTransform: "none",
                  width: "120px",
                  fontFamily: "MilliardMedium"
                }}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          {/* Leave status successfully Model */}
          {/* <Dialog open={showSuccess} onClose={closeSuccess} width={500}>
            <DialogContent>
              <center>
                <img
                  src={Check}
                  alt=""
                  style={{ height: "50px", width: "50px" }}
                />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                Leave {selectedAction == "accept" ? "Approved" : "Rejected"}{" "}
                successfully
              </p>
              <div className="customStyle">
                <Button
                  size="large"
                  key="back"
                  onClick={closeSuccess}
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    color: "white",
                    fontWeight: "500",
                    textTransform: "none",
                  }}
                  fullWidth
                >
                  Ok
                </Button>
              </div>
            </DialogContent>
          </Dialog> */}

          {/* Filter Model */}
          {/* <Dialog open={openFilterModal} className="filter_model">
            <DialogTitle
              id="Leave_title"
              className="d-flex"
              style={{ justifyContent: "space-between" }}
            >
              Filters
              <div>
                <Button
                  onClick={handleClearFilter}
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    color: "white",
                    fontWeight: "500",
                    borderColor: "#244DA0",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                >
                  Clear All
                </Button>
              </div>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <div className="filter_Dialog_employee">
                <Box
                  sx={{
                    flexGrow: 1,
                    bgcolor: "background.paper",
                    display: "flex",
                    height: 224,
                  }}
                >
                  <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={Filtervalue}
                    onChange={handleTChange}
                    aria-label="Vertical tabs example"
                    sx={{ borderRight: 1, borderColor: "divider" }}
                    className="tab_div"
                  >
                    <Tab label="Name" sx={{ textTransform: "none" }} />
                    <Tab label="Status" sx={{ textTransform: "none" }} />
                    <Tab label="Date" sx={{ textTransform: "none" }} />
                  </Tabs>
                  <div>
                    {Filtervalue !== 2 ? (
                      <div className="SearchInput">
                        <TextField
                          className="SearchInput"
                          id="r5"
                          placeholder="Search"
                          value={Filtervalue == 0 ? searchQuery : searchStatus}
                          onChange={
                            Filtervalue == 0
                              ? handleSearchChange
                              : handleSearchStatus
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon style={{ color: "lightgray" }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <TabPanel
                      value={Filtervalue}
                      className="Tab_Panel"
                      index={0}
                    >
                      <div>
                        {userfilter?.length !== 0
                          ? userfilter?.map((ele) => {
                            return (
                              <li className="filter_list">
                                <Checkbox
                                  checked={selectedUserCheckboxes.includes(
                                    ele.name
                                  )}
                                  onChange={() => handleUserChange(ele.name)}
                                  name={ele?.name}
                                  style={{
                                    padding: "0px",
                                    marginRight: "10px",
                                    color: "darkgray",
                                  }}
                                />
                                {ele.name}
                              </li>
                            );
                          })
                          : "No Leave applied for this year"}
                      </div>
                    </TabPanel>
                    <TabPanel
                      value={Filtervalue}
                      className="Tab_Panel"
                      index={1}
                    >
                      <div>
                        {statusfilter.length !== 0
                          ? statusfilter?.map((ele) => {
                            return (
                              <li className="filter_list">
                                <Checkbox
                                  checked={selectedStatusCheckboxes.includes(
                                    ele?.value
                                  )}
                                  onChange={() => handleChange(ele.value)}
                                  name={ele?.value}
                                  style={{
                                    padding: "0px",
                                    marginRight: "10px",
                                    color: "darkgray",
                                  }}
                                />

                                {ele.label}
                              </li>
                            );
                          })
                          : "No Leave applied for this year"}
                      </div>
                    </TabPanel>
                  </div>

                  <TabPanel value={Filtervalue} className="Tab_Panel" index={2}>
                    <div className="DateRange">
                      {/* <Typography className="label_text_profile">Selecte Date :</Typography>
                      <DateRangePicker
                        character=" | "
                        onChange={handleDateChange}
                        ranges={predefinedBottomRanges}
                        showOneCalendar
                        // defaultValue={predefinedBottomRanges[0].value}
                        placeholder={selectedDatesText}
                        size="sm"
                        format="dd-MM-yyyy"
                        className="custom-date-range-picker"
                      /> 
                      <div className="mr_div">
                        <Typography className="label_text">
                          From Date <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={dayjs(startDate)}
                            onChange={(e) => handleDateChange(e)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </div>
                      <div>
                        <Typography className="label_text">
                          To Date <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            minDate={dayjs(startDate)}
                            value={dayjs(endDate)}
                            onChange={(e) => handleToDateChange(e)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="d_flex">
                      <span
                        className="bottom_range"
                        onClick={(key) => handleFilterYear(1)}
                      >
                        This Month
                      </span>
                      <span
                        className="bottom_range"
                        onClick={(key) => handleFilterYear(2)}
                      >
                        Last Month
                      </span>
                      <span
                        className="bottom_range"
                        onClick={(key) => handleFilterYear(3)}
                      >
                        This Year
                      </span>
                      <span
                        className="bottom_range"
                        onClick={(key) => handleFilterYear(4)}
                      >
                        Previous Year
                      </span>
                    </div>
                  </TabPanel>
                </Box>
              </div>
            </DialogContent>
            <Divider />
            <DialogActions
              style={{ justifyContent: "space-around", margin: "0px" }}
            >
              <div className="button-container" onClick={closeFilterModel}>
                <Button
                  block
                  size="large"
                  className="btn_hover_effect"
                  style={{
                    borderRadius: "6px",
                    color: "red",
                    fontWeight: "500",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                >
                  Close
                </Button>
              </div>
              <div className="button-container" onClick={filterdsumbit}>
                <Button
                  size="large"
                  block
                  key="back"
                  className="btn_hover_effect"
                  style={{
                    borderRadius: "6px",
                    color: "#244DA0",
                    fontWeight: "500",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                >
                  Apply
                </Button>
              </div>
            </DialogActions>
          </Dialog> */}

          <div >
            {!loading ? (
              <>
                <TableContainer component={Paper} className="table-container"
                  sx={{
                    // maxHeight: "353px",
                    maxHeight: 'calc(100vh - 265px)',
                    borderTopLeftRadius: 15,
                    borderTopRightRadius: 15,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0
                  }}
                >
                  <Table
                    sx={{
                      minWidth: 650, '& th, & td': {
                        border: '1px solid #f0f0f0',
                      },
                    }}
                    aria-label="simple table"
                  >
                    <TableHead className="table_Header_color" sx={{ height: "50px" }}>
                      <TableRow
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          backgroundColor: "#244DA0",
                        }}
                      >
                        <TableCell style={{ color: "white" }}>
                          Employee Name
                        </TableCell>
                        <TableCell style={{ color: "white" }}>
                          Leave Type
                        </TableCell>
                        <TableCell style={{ color: "white" }}>
                          Start Date
                        </TableCell>
                        <TableCell style={{ color: "white" }}>
                          End Date
                        </TableCell>
                        <TableCell style={{ color: "white" }}>
                          Duration
                        </TableCell>
                        <TableCell style={{ color: "white" }}>
                          Leave Status
                        </TableCell>
                        <TableCell style={{ color: "white" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {filteredActivityArr?.length > 0 ? (
                        filteredActivityArr?.map((row) => (
                          <TableRow
                            key={row.name}
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => {
                              if (row.leave_status === "Pending" || row.leave_status !== "Pending") {
                                setRowData(row);
                              }

                            }}
                          >
                            <TableCell>{row.applied_user_name}</TableCell>
                            <TableCell>{row.leave_title.split(' ').map(word => word[0])} ({row.sub_leave_title.replace(/\s*\(.*?\)\s*/g, '')})
                            </TableCell>
                            <TableCell>
                              {moment(new Date(row.start_date)).format(
                                "DD-MM-YYYY"
                              )}
                            </TableCell>
                            <TableCell>
                              {moment(new Date(row.end_date)).format(
                                "DD-MM-YYYY"
                              )}
                            </TableCell>
                            <TableCell>{`${row.days} Day${row.days > 1 ? "s" : ""
                              }`}</TableCell>
                            <TableCell>
                              {<LeaveStatus status={row.leave_status} />}
                            </TableCell>
                            <TableCell>

                              {row.leave_status === "Approved" && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-evenly",
                                  }}
                                >
                                  <Tooltip title="Cancel">
                                    <CancelRoundedIcon
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        rejectPopup(row, "Cancel")
                                      }}
                                      style={{
                                        border: "none",
                                        color: "red",
                                        fontSize: "17px",
                                        cursor: "pointer",
                                        // backgroundColor: "red",
                                      }}
                                    />
                                  </Tooltip>

                                  <Tooltip title="View">
                                    <VisibilityIcon
                                      onClick={() => setRowData(row)}
                                      style={{
                                        border: "none",
                                        color: "#c8cfe3ff",
                                        fontSize: "17px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Tooltip>

                                </div>
                              )}

                              {/* <div></div> */}
                              <div style={{ display: "flex", justifyContent: "center" }}>
                                {
                                  row.leave_status === "Rejected" && (
                                    <Tooltip title="View">
                                      <VisibilityIcon
                                        onClick={() => setRowData(row)}
                                        style={{
                                          border: "none",
                                          color: "#c8cfe3ff",
                                          fontSize: "17px",
                                          cursor: "pointer",
                                          justifySelf: "center"
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                              </div>

                              {row.leave_status === "Pending" && (
                                <div style={{ display: 'flex', justifyContent: "space-evenly" }}>
                                  <Tooltip title="Accept">
                                    <CheckCircleIcon
                                      style={{
                                        color: "green",
                                        border: "none",
                                        fontSize: "17px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        acceptPopup(row)
                                      }}
                                    />
                                  </Tooltip>

                                  <Tooltip title="Reject">
                                    <ThumbDownIcon
                                      style={{
                                        color: "red",
                                        border: "none",
                                        fontSize: "17px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        rejectPopup(row, "Reject")
                                      }}
                                    />
                                  </Tooltip>

                                  <Tooltip title="View">
                                    <VisibilityIcon
                                      onClick={() => setRowData(row)}
                                      style={{
                                        border: "none",
                                        color: "#c8cfe3ff",
                                        fontSize: "17px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Tooltip>
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan="7">
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              No Records found
                            </span>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                {data?.length > 0 ?
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                      <div>
                        <Typography variant="body2" style={{ marginRight: "8px", display: "inline" }}>
                          Rows per page:
                        </Typography>
                        <select
                          value={limit}
                          onChange={(e) => {
                            setLimit(parseInt(e.target.value));
                            setCurrentPage(1); // Reset to first page on limit change
                          }}
                          style={{
                            padding: "6px 12px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            outline: "none",
                          }}
                        >
                          {[20, 50, 100].map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      color="primary"
                      className="pagination"
                      onChange={handlePageChange}
                    />
                  </div>
                  : (
                    null
                  )}
              </>
            ) : (
              <span class="loader"></span>
            )}
          </div>
        </Card>
      </div >
    </LeaveStyle >
  );
}
